import React from "react";
import "./Navbar.scss";
import logo from "../../assets/images/logo.svg";
import Button from "../Utils/Button";
import discord from "../../assets/images/discord.svg";

function Navbar() {
  return (
    <nav>
      <div className="container">
        <div className="logo">
          <img src={logo} alt="IndiGG" title="IndiGG" loading="lazy" />
        </div>
        <Button text={"Join our Discord"} image={discord} />
      </div>
    </nav>
  );
}

export default Navbar;
